class ProgressBarData {
  private readonly _percentage: number;
  private readonly _animateChange: boolean;

  constructor(percentage: number, animateChange: boolean) {
    this._percentage = Math.round(percentage);
    this._animateChange = animateChange;
  }

  get percentage() {
    return this._percentage;
  }

  get animateChange() {
    return this._animateChange;
  }
}

export default ProgressBarData;
